// Populates per-line breakdown rows on the cart page. Reads the cart pricing
// result from the Northbound runtime and writes Product / Shipping before
// subsidy / NNC subsidy / Landed cents into the corresponding slots inside each
// `[data-cart-line-breakdown]` block.
//
// Per-line shipping and subsidy aren't exposed as DOM slots today, so we go
// through the JS API. Re-queries DOM on every event, so it survives Dawn's
// `.js-contents` innerHTML replacement after qty changes. The cart page also
// has mobile and desktop line-total cells; Northbound updates the first
// matching slot per line, so this file mirrors that hydrated value into
// responsive duplicate slots after pricing events.

(function () {
  if (window.__arcticCartItemBreakdownReady) return;
  window.__arcticCartItemBreakdownReady = true;

  function formatMoney(cents) {
    var normalized = Number.isFinite(cents) ? Math.round(cents) : 0;
    var runtime = window.__northboundStorefrontRuntime;
    var helpers = runtime && runtime.helpers;
    if (helpers && typeof helpers.formatMoney === 'function') {
      return helpers.formatMoney(normalized);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(normalized);
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'CAD',
    }).format(normalized / 100);
  }

  function setText(node, selector, value) {
    var el = node.querySelector(selector);
    if (el) el.textContent = value;
  }

  function syncResponsiveLineTotals() {
    document.querySelectorAll('[data-northbound-cart-line]').forEach(function (line) {
      var totals = Array.prototype.slice.call(
        line.querySelectorAll('[data-northbound-cart-line-total]')
      );
      if (totals.length < 2) return;

      var sourceText = totals[0].textContent;
      totals.slice(1).forEach(function (node) {
        node.textContent = sourceText;
      });
    });
  }

  function applyToNode(node, line) {
    if (!line) {
      node.hidden = true;
      return;
    }

    var unitPriceCents = Number(line.unitPriceCents) || 0;
    var quantity = Number(line.quantity) || 0;
    var productCents = unitPriceCents * quantity;
    // cartDisplayShippingCents is the net shipping amount used in the landed
    // total. The visible receipt shows shipping before subsidy, then subtracts
    // the subsidy as its own row so the math reads like a regular receipt.
    var shippingCents = Number(line.cartDisplayShippingCents);
    if (!Number.isFinite(shippingCents)) shippingCents = Number(line.estimatedShippingCents) || 0;
    var subsidyCents = Number(line.subsidyCents) || 0;
    var shippingBeforeSubsidyCents = shippingCents + subsidyCents;
    var landedCents = Number(line.cartDisplayLinePriceCents) || 0;

    setText(node, '[data-breakdown-product]', formatMoney(productCents));
    setText(node, '[data-breakdown-shipping]', formatMoney(shippingBeforeSubsidyCents));
    setText(node, '[data-breakdown-landed]', formatMoney(landedCents));

    var subsidyRow = node.querySelector('[data-breakdown-subsidy-row]');
    if (subsidyCents > 0) {
      setText(node, '[data-breakdown-subsidy]', '-' + formatMoney(subsidyCents));
      if (subsidyRow) subsidyRow.hidden = false;
    } else if (subsidyRow) {
      subsidyRow.hidden = true;
    }

    node.hidden = false;
  }

  function applyAll(result) {
    var nodes = document.querySelectorAll('[data-cart-line-breakdown]');
    if (!nodes.length) return;

    var lines = (result && result.lines) || {};
    nodes.forEach(function (node) {
      var variantId = node.getAttribute('data-variant-id');
      applyToNode(node, lines[variantId]);
    });
  }

  function getLatest() {
    var api = window.NorthboundStorefront;
    if (!api || typeof api.getCartPricingResult !== 'function') return null;
    try {
      return api.getCartPricingResult();
    } catch (err) {
      return null;
    }
  }

  function init() {
    applyAll(getLatest());
    syncResponsiveLineTotals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('northbound:cart-pricing-applied', function (event) {
    var result = event.detail && event.detail.cartPricingResult;
    applyAll(result);
    syncResponsiveLineTotals();
  });

  window.addEventListener('northbound:community-changed', function () {
    document.querySelectorAll('[data-cart-line-breakdown]').forEach(function (node) {
      node.hidden = true;
    });
  });
})();
